/* eslint-disable */
import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ContainerFull = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  width: 100%;
  margin-top: auto;
  background: #0C053F;

  @media (min-width: 768px) {
    min-height: 300px;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${p => (p.column ? 'column' : 'row')};
  width: 100%;
  margin: 0 auto;
  justify-content: flex-start;

  @media (min-width: 768px) {
    max-width: 1100px;
    height: 100%;
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 70px 0px;

  &.white {
    background: #FFFFFF;
  }
  @media (max-width: 767px) {
    padding: 40px;
  }

  @media (min-width: 768px) {
    padding: 70px 40px;
  }

  @media (min-width: 992px) {
    padding: 70px 20px;
  }

  @media (min-width: 1200px) {
    padding: 70px 0px;
  }

  @media (min-width: 1600px) {
    padding: 70px 0px;
  }
`;

export const Title = styled(motion.h1)`
  font-size: 25px;
  line-height: 36px;
  margin-bottom: 30px;
  letter-spacing: 0;
  color: #ffffff;
  font-weight: 400;
  text-align: justify;
  text-justify: inter-word;

  @media (min-width: 768px) {
    font-size: 16px;
  }

  @media (min-width: 992px) {
    font-size: 18px;
  }

  @media (min-width: 1200px) {
    font-size: 20px;
  }

  @media (min-width: 1600px) {
    font-size: 25px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 22px;
    padding: 0;
    margin: 0;
    text-align: justify;
    text-justify: inter-word;
  }
`;

export const Text = styled(motion.p)`
  font-size: 40px;
  color: #ffffff;
  font-weight: 400;
  padding: 0 40px;

  @media (max-width: 767px) {
    color: #0C053F;
    padding: 0;
    font-size: 24px;
    text-align: justify;
    text-justify: inter-word;
  }
`;

export const ButtonClose = styled.button`
  width: 30px;
  height: 30px;
  border: 0;
  outline: 0;
  cursor: pointer;
  display: flex;
  background: transparent;
  align-items: center;
  justify-content: center;
`;

export const Button = styled(motion.div)`
  border: solid 1px #ffffff;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px 9px 20px;
  border-radius: 40px;
  color: #ffffff;
  cursor: pointer;
  background: rgba(255, 255, 255, 0);
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (min-width: 768px) {
    margin-top: 90px;
  }
`;

export const CardsContainer = styled(motion.div)`
  width: 100%;
  margin-top: 100px;
  display: flex;
  justify-content: space-between;
`;

export const Card = styled.div`
  display: flex;
  height: auto;
  padding: 20px 15px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  background: #130b4a;
  box-shadow: 3px 10px 20px 0px rgba(0, 0, 0, 0.5);

  h2 {
    width: auto;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    color: #ffffff;
    white-space: nowrap;
  }

  p {
    width: 260px;
    text-align: left;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: #f7f7f7;
  }
`;
